import React from "react";
import { RODEO_PAGE_NAME } from "src/_config";
import Sidebar from "src/components/common/Sidebar";
const LazyPerformanceLanding = React.lazy(() => import("src/components/performance-landing/PerformanceLanding"));

export default function PerformanceLandingContainer(props: Record<string, any>) {
  return (
    <React.Fragment>
      <Sidebar page={RODEO_PAGE_NAME.PERFORMANCE_LANDING} />
      <React.Suspense
        fallback={
          <div className="transition-loader">
            <img src="/images/running-horse.gif" />
          </div>
        }
      >
        <LazyPerformanceLanding {...props} />
      </React.Suspense>
    </React.Fragment>
  );
}
